import 'react-day-picker/style.css'
import './react-day-picker.css'
import { lazy, Suspense } from 'react'

const DayPicker = lazy(async () => {
  const module = await import('react-day-picker')
  return { default: module.DayPicker }
})

const Calendar = (props: React.ComponentProps<typeof DayPicker>) => {
  return (
    <Suspense>
      <DayPicker showOutsideDays {...props} />
    </Suspense>
  )
}

export default Calendar
